import type { RiskBreakdownEntry } from "./api"

export function RiskBreakdown({ breakdown, score }: { breakdown: RiskBreakdownEntry[]; score: number }) {
    if (breakdown.length === 0) return null

    const rawTotal = breakdown.reduce((sum, b) => sum + b.contribution, 0)
    const maxContribution = Math.max(...breakdown.map((b) => b.contribution), 1)

    return (
        <div className="risk-breakdown">
            <h4>Why this score?</h4>
            {rawTotal > 100 && (
                <p className="muted">
                    Raw total {rawTotal} clamped to 100 — {breakdown[0]?.type} is the heaviest factor.
                </p>
            )}
            <ul className="risk-bars">
                {breakdown.map((entry, i) => (
                    <li key={entry.type}>
                        <div className="risk-bar-label">
                            <span className={i === 0 ? "risk-bar-type heaviest" : "risk-bar-type"}>
                                {entry.type}
                            </span>
                            <span className="muted">
                                weight {entry.weight} × {(entry.maxConfidence * 100).toFixed(0)}% confidence
                            </span>
                        </div>
                        <div className="risk-bar-track">
                            <div
                                className={i === 0 ? "risk-bar-fill heaviest" : "risk-bar-fill"}
                                style={{ width: `${(entry.contribution / maxContribution) * 100}%` }}
                            />
                        </div>
                        <span className="risk-bar-value">+{entry.contribution}</span>
                    </li>
                ))}
            </ul>
        </div>
    )
}
